import { getCategory } from "../../api/categories.js";
/* eslint-disable react-hooks/exhaustive-deps */
import { Edit } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import { Button, IconButton, Paper } from "@mui/material";
import { useEffect, useLayoutEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { PageTitle } from "../../../../shared/ui/common/index.js";
import Exports from "../../../../shared/ui/common/export.jsx";
import CustomeLayout from "../../../../shared/ui/customeTable.jsx";
import DataFetcher from "../../../../shared/api/index.js";
import Filters from "../../../../shared/ui/filters/index.jsx";

import { GET_ALL_CATEGORY, EDIT_CATEGORY_ACTIVE, EXPORT_CATEGORY } from "../../../../shared/api/endpoints.js";
import CategoryModal from "./modal.jsx";

const Categories = () => {
  const { token } = useSelector((state) => state.user);

  const { userPermissions } = useSelector((state) => state.relationals);
  const [openCreate, setOpenCreate] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [editingData, setEditingData] = useState({});
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState([]);
  const [sort, setSort] = useState({});
  const [current, setCurrent] = useState({});

  const [search, setsearch] = useState("");
  const [sumbitSearch, setSumbitSearch] = useState("");
  const [limit, setLimit] = useState(50);
  const [allRows, setAllRows] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [filterApplied, setFilterApplied] = useState([]);
  const [selected, setSelected] = useState([]);
  const [refreshData, setRefresh] = useState(0);
  useLayoutEffect(() => {
    var temp = filter;
    var a = location?.hash ? location?.hash?.slice(1).split(",") : [];
    temp = temp.filter((item) => item?.name !== "parentId");
    temp.push({
      name: "parentId",
      value: location?.hash ? a[a?.length - 1] : null,
      type: "eq",
    });
    if (location?.hash) {
      getCategory(a[a?.length - 1], token)
        .then((res) => {
          const { data } = res;
          setCurrent(res?.data?.data);
        })
        .catch((err) => {
          if (err.response.status === 401) {
          }
        });
    } else {
      setCurrent({});
    }
    setFilterApplied(temp);
  }, [filter, location?.hash]);
  const { hasMore, loading, allData, CurrentPage, metaData, header, setting } =
    DataFetcher(
      limit,
      page,
      sort,
      GET_ALL_CATEGORY,
      filterApplied,
      true,
      refreshData,
      sumbitSearch
    );
  useEffect(() => {
    setAllRows(allData);
  }, [allData]);

  return (
    <>
      <PageTitle
        title="دسته بندی ها"
        broadCrumb={[
          {
            title: ` دسته بندی `,
            path: "/category",
          },
        ]}
      />
      <div className="md:mx-3 mx-1">
        <Paper
          sx={{ border: "1px solid #dbdfea", mb: 1, padding: "15px 16px" }}
          elevation={0}
        >
          <div className="flex md:gap-4 gap-1 flex-wrap justify-between">
            <Filters
              limit={limit}
              setLimit={setLimit}
              headers={header}
              setFilter={setFilter}
              filter={filter}
              setPage={setPage}
              loading={loading}
            />
            <div className="flex justify-end flex-wrap gap-4 items-center">
              <Exports
                sumbitSearch={sumbitSearch}
                filter={filter}
                header={header}
                data={allData}
                selectedData={selected}
                title={` دسته بندی ${current?.title ? current?.title : ""}`}
                api={EXPORT_CATEGORY}
                param={
                  location?.hash !== ""
                    ? `&filter[0][key]=parentId&filter[0][value]=${
                        location?.hash?.slice(1).split(",")[
                          location?.hash?.slice(1).split(",")?.length - 1
                        ]
                      }&filter[0][operator]=eq`
                    : "&filter[0][key]=parentId&filter[0][value]=null&filter[0][operator]=eq"
                }
              />

              <Button onClick={() => setOpenCreate(true)} variant="contained">
                <AddIcon />
                افزودن دسته بندی جدید
              </Button>
            </div>
          </div>
        </Paper>
        <CustomeLayout
          limit={limit}
          setLimit={setLimit}
          setAllRows={setAllRows}
          editApi={EDIT_CATEGORY_ACTIVE}
          title={` دسته بندی ${current?.title ? current?.title : ""}`}
          headers={header}
          setSearch={setsearch}
          search={search}
          page={page}
          total_pages={metaData?.total_pages}
          setApplySearch={(e) => {
            setPage(1);
            setSumbitSearch(e);
            /* setFilter({ ...filter, search: { value: e, type: "lk" } }); */
          }}
          rows={allRows || []}
          hasMore={hasMore}
          loading={loading}
          setPage={setPage}
          setting={setting}
          CurrentPage={CurrentPage}
          actions={[
            {
              title: "مشاهده / ویرایش فیلد",
              handler: (
                <>
                  <Button
                    onClick={() =>
                      window.open(
                        `/category/${editingData?.id}?isParent=${
                          editingData?.parentId === null ? true : false
                        }&title=${editingData?.title}`
                      )
                    }
                    variant="contained"
                    color="warning"
                  >
                    مشاهده
                  </Button>
                </>
              ),
            },
            {
              title: "مشاهده   فرزندان",
              handler: (
                <>
                  <Button
                    onClick={() => {
                      if (location?.hash) {
                        window.open(
                          `${location?.pathname}${location?.hash},${editingData?.id}`
                        );
                      } else {
                        window.open(`${location?.pathname}#${editingData?.id}`);
                      }
                    }}
                    variant="contained"
                    color="success"
                  >
                    مشاهده
                  </Button>
                </>
              ),
            },
            {
              title: "ویرایش",
              handler: (
                <>
                  <IconButton
                    onClick={() => {
                      setOpenEdit(true);
                    }}
                  >
                    <Edit sx={{ color: "#ff2000" }} />
                  </IconButton>
                </>
              ),
            },
          ]}
          length={metaData?.total}
          name={"دسته بندی "}
          maxHeight={{ lg: "69.5vh", md: "68vh", xl: "74vh" }}
          setSort={(e) => {
            setPage(1);
            setSort({ ...sort, ...e });
          }}
          currentRow={(data) => {
            setEditingData(data);
          }}
          setRefresh={setRefresh}
          setSelected={setSelected}
          selected={selected}
        />
      </div>
      <CategoryModal
        open={openEdit || openCreate}
        forEdit={openEdit}
        data={editingData}
        setAllRows={setAllRows}
        allRows={allRows}
        close={() => {
          setOpenCreate(false);
          setOpenEdit(false);
          setEditingData({});
        }}
      />
    </>
  );
};

export default Categories;
